module.exports = __webpack_public_path__ + "media/images/flags/is-7eda7cfe70940d17cb21326764a2a5ff.svg";